// covered-by: frontends/carrie/src/ask-v2/shell/__tests__/askV2ChatNavigation.test.ts
import { ASK_V2_CHAT_PATH, ASK_V2_PROJECT_PATH, askV2ChatPath } from "../paths";

export type AskV2ChatNavSource = {
  _id: string;
  projectId?: string | null;
  projectChatKind?: "shared" | "personal" | null;
};

export type AskV2RouteMatch = {
  pathname?: string;
  params?: Record<string, unknown>;
};

export function isProjectPersonalChat(chat: AskV2ChatNavSource): boolean {
  return Boolean(chat.projectId && chat.projectChatKind === "personal");
}

/**
 * V2 has no project-scoped chat route yet. Personal project chats use the
 * standalone chat path until that page lands.
 */
export function askV2ChatNavLink(chat: AskV2ChatNavSource) {
  return {
    to: ASK_V2_CHAT_PATH,
    params: { chatId: chat._id },
  } as const;
}

export function askV2ProjectNavLink(projectId: string) {
  return {
    to: ASK_V2_PROJECT_PATH,
    params: { projectId },
  } as const;
}

export function isAskV2ChatNavActive(
  chat: AskV2ChatNavSource,
  matches: AskV2RouteMatch[],
): boolean {
  return matches.some((m) => m.params?.chatId === chat._id);
}

export function isAskV2ProjectNavActive(
  projectId: string,
  matches: AskV2RouteMatch[],
): boolean {
  return matches.some((m) => m.params?.projectId === projectId);
}

export function isViewingAskV2Chat(
  chat: AskV2ChatNavSource,
  pathname: string,
): boolean {
  return pathname.includes(askV2ChatPath(chat._id));
}
